export default {"src":"/_next/static/media/homepage-twitter-footer-icon-desktop.b375f218.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};